import styles from "./styles.module.scss";
import { SubmittedProjectNameLabelProps } from "./type";

export const SubmittedProjectNameLabel = ({
  projectName,
}: SubmittedProjectNameLabelProps) => {
  return <span className={styles.project_name_link}>{projectName}</span>;
};
